import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_LIBRARY_PROBLEMS } from '../../constants/ActionTypes';
import { getProblemsFromLibrary } from '../../api/Interviews/problems.api';
import {
  IGetLibraryProblems,
  TGetLibraryProblemsParams,
} from '../../types/Interviews/problem.types';
import { showAlert } from '../../actions/alert.action';
import { EAlertType } from '../../types/alert.types';
import { apiErrorHandler } from '../../utils/api-helpers';
import { HTTP_STATUS_CODES } from '../../constants/HttpConstants';
import {
  INTERVIEW_PROBLEM_LIBRARY_API_HTTP_STATUS_CODES,
  INTERVIEW_PROBLEM_LIBRARY_ERROR_MESSAGE,
} from '../../constants/Interviews/LibraryConstants';

function* getLibraryProblems({ payload }: IGetLibraryProblems) {
  try {
    const {
      level,
      limit,
      offset,
      category,
      problemType,
      slug,
      query,
      tags,
      technologies,
    } = payload;
    let params: TGetLibraryProblemsParams = {
      limit,
      offset,
      problem_type: problemType,
      query,
      tags,
      level,
      technologies,
    };

    if (category === 'interview') {
      params = { ...params, interview_slug: slug };
    } else {
      params = { ...params, category };
    }

    const problemLibraryResp: AxiosResponse = yield call(
      getProblemsFromLibrary,
      params
    );

    if (problemLibraryResp.status === HTTP_STATUS_CODES.OK) {
      yield put({
        type: `${GET_LIBRARY_PROBLEMS}_SUCCESS`,
        payload: {
          results: problemLibraryResp.data.results,
          meta: {
            previouse: problemLibraryResp.data.previous,
            next: problemLibraryResp.data.next,
            count: problemLibraryResp.data.count,
            totalPages: Math.ceil(problemLibraryResp.data.count / +limit),
          },
        },
      });
    } else {
      yield put(
        showAlert({
          show: true,
          message: INTERVIEW_PROBLEM_LIBRARY_ERROR_MESSAGE,
          type: EAlertType.ERROR,
        })
      );
    }
  } catch (error: any) {
    const message: string | null = apiErrorHandler(
      error,
      INTERVIEW_PROBLEM_LIBRARY_API_HTTP_STATUS_CODES,
      INTERVIEW_PROBLEM_LIBRARY_ERROR_MESSAGE
    );
    if (message) {
      yield put(
        showAlert({
          show: true,
          message,
          type: EAlertType.ERROR,
        })
      );
    }
  }
}

export default function* loadLibrarySaga() {
  yield takeLatest(GET_LIBRARY_PROBLEMS, getLibraryProblems);
}
